export default function safeValue(value, coma = false) {
  if (!value) {
    return '';
  }
  return coma ? `${value}, ` : value;
}
